import {Component, Input, OnInit} from '@angular/core';
import {PatientImage} from '@interfaces/report';
import {NgOptimizedImage} from '@angular/common';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'app-request-image',
  imports: [
    NgOptimizedImage,
    MatIcon
  ],
  templateUrl: './request-image.component.html',
  standalone: true,
  styleUrl: './request-image.component.scss'
})
export class RequestImageComponent implements OnInit {
  @Input() images!: PatientImage[];
  selectedImage?: PatientImage;

  ngOnInit() {
    if (this.images.length > 0) {
      this.selectedImage = this.images[0];
    }
  }

  loadImage(image: PatientImage) {
    this.selectedImage = image;
  }

}
